import { useRef } from 'react';
import { CATEGORY_LABELS } from './ActivityList';

const BASE_CATEGORIES = ['requests', 'access', 'apps', 'profile'];

/**
 * Who segmented control (All / By me / About me) + single-select category
 * chips. The segmented control is a radiogroup with roving arrow-key focus.
 */
export default function ActivityFilters({ who, category, onWho, onCategory, subjectName, isSelf, showAdmin }) {
  const refs = useRef([]);
  const first = String(subjectName || '').trim().split(/\s+/)[0] || 'them';
  const options = [
    { key: 'all', label: 'All' },
    { key: 'by', label: isSelf ? 'By me' : `By ${first}` },
    { key: 'about', label: isSelf ? 'About me' : `About ${first}` },
  ];
  const categories = showAdmin ? [...BASE_CATEGORIES, 'admin'] : BASE_CATEGORIES;

  const onKeyDown = (e, i) => {
    const step = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
    if (!step) return;
    e.preventDefault();
    const next = (i + step + options.length) % options.length;
    onWho(options[next].key);
    refs.current[next]?.focus();
  };

  return (
    <div className="act-filters">
      <div className="act-seg" role="radiogroup" aria-label="Whose actions">
        {options.map((o, i) => (
          <button
            key={o.key}
            ref={(el) => { refs.current[i] = el; }}
            type="button"
            role="radio"
            aria-checked={who === o.key}
            tabIndex={who === o.key ? 0 : -1}
            className={`act-seg__opt${who === o.key ? ' is-active' : ''}`}
            title={o.label}
            onClick={() => onWho(o.key)}
            onKeyDown={(e) => onKeyDown(e, i)}
          >
            {o.label}
          </button>
        ))}
      </div>
      <div className="act-chips" role="group" aria-label="Filter by kind">
        {categories.map((c) => (
          <button
            key={c}
            type="button"
            aria-pressed={category === c}
            className={`act-chip${category === c ? ' is-active' : ''}`}
            onClick={() => onCategory(category === c ? null : c)}
          >
            {CATEGORY_LABELS[c]}
          </button>
        ))}
      </div>
    </div>
  );
}
